<div class="other-products-container">
  <div class="other-products-content">

    <!-- ── Header ── -->
    <div class="list-header">
      <h5>{{ selectedProduct ? selectedProduct.label : 'Other Products' }}</h5>

      <div class="list-actions">

        <!-- Product Dropdown -->
        <div class="product-dropdown-wrapper">
          <div class="input-group custom-dropdown" [class.dropdown-open]="isDropdownOpen">

            <span class="input-group-text bg-transparent icon-prefix">
              <i class="bi bi-grid-3x3-gap"></i>
            </span>

            <div class="form-control dropdown-trigger" (click)="toggleDropdown()">
              <span class="trigger-label">
                {{ selectedProduct ? selectedProduct.label : 'Select Product' }}
              </span>
              <i class="bi dropdown-arrow"
                 [ngClass]="isDropdownOpen ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </div>

            <span class="input-group-text bg-transparent clear-btn-wrap"
                  *ngIf="selectedProduct"
                  (click)="clearProduct()"
                  style="cursor: pointer;">
              <i class="bi bi-x-circle"></i>
            </span>

            <!-- Dropdown Menu -->
            <div class="cdd-menu" *ngIf="isDropdownOpen">
              <div class="cdd-option"
                   *ngFor="let product of products"
                   [ngClass]="{'cdd-option-active': selectedProduct?.key === product.key}"
                   (click)="selectProduct(product)">
                <i class="bi bi-check cdd-check"></i>
                <span class="cdd-label">{{ product.label }}</span>
                <!-- <span class="cdd-api-badge" [ngClass]="product.apiType === 'consumer' ? 'badge-consumer' : 'badge-professional'">
                  {{ product.apiType === 'consumer' ? 'Consumer' : 'Professional' }}
                </span> -->
              </div>
            </div>

          </div>
        </div>

        <!-- Search — shown only after product is selected -->
        <div class="search-box" *ngIf="selectedProduct">
          <div class="input-group">
            <span class="input-group-text bg-transparent" style="border: 0px !important">
              <i class="bi bi-search"></i>
            </span>
            <input
              type="text"
              class="form-control"
              style="padding: 0px !important; border: 0px !important"
              [placeholder]="isConsumerMode()
                ? 'Search by name, email, phone...'
                : 'Search by firm, contact, email...'"
              [(ngModel)]="searchQuery"
              (input)="onSearch()"
              (keyup.enter)="onSearch()">
            <span class="input-group-text bg-transparent clear-btn-wrap"
                  *ngIf="searchQuery"
                  (click)="clearSearch()"
                  style="cursor: pointer;">
              <i class="bi bi-x-circle"></i>
            </span>
          </div>
        </div>

        <!-- Add customer — RegsWatch only -->
        <button type="button" class="btn-add-customer"
                *ngIf="selectedProduct?.key === 'regswatch'"
                (click)="openAddModal()">
          <i class="bi bi-plus-lg me-1"></i> Add Customer
        </button>

        <!-- Count badge -->
        <div class="count-badge" *ngIf="selectedProduct && !isLoading && dataSource.length > 0">
          <i class="bi bi-people-fill me-1"></i>
          {{ dataSource.length }} record{{ dataSource.length !== 1 ? 's' : '' }}
        </div>

      </div>
    </div>

    <!-- ════════════════════════════════════════════════════
         TABLE A — Consumer (Vitagist)
    ═════════════════════════════════════════════════════ -->
    <div class="records-table" [class.loading]="isLoading"
         *ngIf="isConsumerMode() && !isLoading && dataSource.length > 0">
      <table class="table">
        <thead>
          <tr>
            <th class="thdata sortable-col" scope="col" (click)="sortBy('name')">
              Name <i class="bi sort-icon" [ngClass]="getSortIcon('name')"></i>
            </th>
            <th class="thdata sortable-col hide-md" scope="col" (click)="sortBy('email')">
              Email <i class="bi sort-icon" [ngClass]="getSortIcon('email')"></i>
            </th>
            <th class="thdata hide-md" scope="col">Phone</th>
            <th class="thdata sortable-col hide-lg" scope="col" (click)="sortBy('account_activation_date')">
              Account Activation Date <i class="bi sort-icon" [ngClass]="getSortIcon('account_activation_date')"></i>
            </th>
            <th class="thdata sortable-col" scope="col" (click)="sortBy('last_login')">
              Last Login <i class="bi sort-icon" [ngClass]="getSortIcon('last_login')"></i>
            </th>
            <th class="thdata sortable-col" scope="col" (click)="sortBy('status')">
              Status <i class="bi sort-icon" [ngClass]="getSortIcon('status')"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of getPage()">
            <td>
              <div class="record-name">
                <span class="record-avatar">{{ getInitials(r) }}</span>
                <span>{{ getConsumerFullName(r) }}</span>
              </div>
            </td>
            <td class="hide-md email-cell">
              <a *ngIf="r['email']" [href]="'mailto:' + r['email']" class="email-link">
                {{ r['email'] }}
              </a>
              <span *ngIf="!r['email']">-</span>
            </td>
            <td class="hide-md">{{ r['phone'] || '-' }}</td>
            <td class="hide-lg">{{ formatDate(r['account_activation_date']) }}</td>
            <td>
              <span>
                {{ r['last_login'] ? formatDateTime(r['last_login']) : 'Never' }}
              </span>
            </td>
            <td>
              <span class="status-badge" [ngClass]="getStatusClass(r['status'])">
                {{ r['status'] | titlecase }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ════════════════════════════════════════════════════
         TABLE B — Professional (Dilite / Connect / Content / RegsWatch)
    ═════════════════════════════════════════════════════ -->
    <div class="records-table" [class.loading]="isLoading"
         *ngIf="isProfessionalMode() && !isLoading && dataSource.length > 0">
      <table class="table">
        <thead>
          <tr>
            <th class="thdata sortable-col" scope="col" (click)="sortBy('name')">
              Firm Name <i class="bi sort-icon" [ngClass]="getSortIcon('name')"></i>
            </th>
            <th class="thdata sortable-col" scope="col" (click)="sortBy('contact_person')">
              Contact Person <i class="bi sort-icon" [ngClass]="getSortIcon('contact_person')"></i>
            </th>
            <th class="thdata sortable-col hide-md" scope="col" (click)="sortBy('email')">
              Email <i class="bi sort-icon" [ngClass]="getSortIcon('email')"></i>
            </th>
            <th class="thdata hide-md" scope="col">Phone</th>
            <th class="thdata sortable-col hide-lg" scope="col" (click)="sortBy('joined')">
              Joined <i class="bi sort-icon" [ngClass]="getSortIcon('joined')"></i>
            </th>
            <th class="thdata sortable-col" scope="col" (click)="sortBy('status')">
              Status <i class="bi sort-icon" [ngClass]="getSortIcon('status')"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of getPage()">
            <td>
              <div class="record-name">
                <span class="record-avatar">{{ getInitials(r) }}</span>
                <span>{{ r['name'] || '-' }}</span>
              </div>
            </td>
            <td>{{ r['contact_person'] || '-' }}</td>
            <td class="hide-md email-cell">
              <a *ngIf="r['email']" [href]="'mailto:' + r['email']" class="email-link">
                {{ r['email'] }}
              </a>
              <span *ngIf="!r['email']">-</span>
            </td>
            <td class="hide-md">{{ r['contact_phone'] || '-' }}</td>
            <td class="hide-lg">{{ formatDate(r['joined']) }}</td>
            <td>
              <span class="status-badge" [ngClass]="getStatusClass(r['status'])">
                {{ r['status'] | titlecase }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ── Skeleton loader ── -->
    <div *ngIf="isLoading" class="skeleton-wrapper">
      <div class="skeleton-row" *ngFor="let i of [1,2,3,4,5,6,7]">
        <div class="skeleton-cell avatar-cell"></div>
        <div class="skeleton-cell wide"></div>
        <div class="skeleton-cell medium hide-md"></div>
        <div class="skeleton-cell wide hide-md"></div>
        <div class="skeleton-cell medium hide-lg"></div>
        <div class="skeleton-cell short"></div>
      </div>
    </div>

    <!-- ── Empty state: no product selected ── -->
    <div *ngIf="!selectedProduct && !isLoading" class="empty-state">
      <i class="bi bi-layers empty-icon"></i>
      <p class="empty-title">Select a Product</p>
      <p class="empty-sub">Choose a product from the dropdown to view its records.</p>
    </div>

    <!-- ── Empty state: product selected but no data ── -->
    <div *ngIf="selectedProduct && !isLoading && dataSource.length === 0" class="empty-state">
      <i class="bi bi-inbox empty-icon"></i>
      <p class="empty-title">No Records Found</p>
      <p class="empty-sub">
        {{ searchQuery
            ? 'No results match your search criteria.'
            : 'No records available for ' + selectedProduct.label + '.' }}
      </p>
    </div>

    <!-- ── Pagination ── -->
    <div class="pagination-area" *ngIf="selectedProduct && !isLoading && dataSource.length > 0">
      <div class="pagination-info">{{ getPaginationRange() }}</div>
      <nav aria-label="Other products pagination">
        <ul class="pagination mb-0">
          <li class="page-item" [ngClass]="{'disabled': pageIndex === 0}">
            <a class="page-link" href="javascript:void(0)" (click)="goToFirstPage()">
              <i class="bi bi-chevron-double-left biarr"></i>
            </a>
          </li>
          <li class="page-item" [ngClass]="{'disabled': pageIndex === 0}">
            <a class="page-link" href="javascript:void(0)" (click)="goToPrevPage()">
              <i class="bi bi-chevron-left biarr"></i> Previous
            </a>
          </li>
          <li *ngFor="let page of getPageNumbers()" class="page-item"
              [ngClass]="{'active': page === pageIndex + 1}">
            <a class="page-link" href="javascript:void(0)"
               (click)="goToPage(page - 1)">{{ page }}</a>
          </li>
          <li class="page-item" [ngClass]="{'disabled': pageIndex >= getTotalPages() - 1}">
            <a class="page-link" href="javascript:void(0)" (click)="goToNextPage()">
              Next <i class="bi bi-chevron-right biarr"></i>
            </a>
          </li>
          <li class="page-item" [ngClass]="{'disabled': pageIndex >= getTotalPages() - 1}">
            <a class="page-link" href="javascript:void(0)" (click)="goToLastPage()">
              <i class="bi bi-chevron-double-right biarr"></i>
            </a>
          </li>
        </ul>
      </nav>
    </div>

  </div>
</div>

<!-- ── Add Customer modal ── -->
<div class="add-modal-backdrop" *ngIf="showAddModal" (click)="closeAddModal()">
  <div class="add-modal" (click)="$event.stopPropagation()">
    <div class="add-modal-header">
      <h6>Add RegsWatch Customer</h6>
      <i class="bi bi-x-lg" style="cursor:pointer" (click)="closeAddModal()"></i>
    </div>
    <form (ngSubmit)="saveCustomer()" #addForm="ngForm">
      <div class="add-modal-body">
        <label>Full Name *
          <input class="form-control" name="fullname" [(ngModel)]="newCustomer.fullname" required>
        </label>
        <label>Country *
          <input class="form-control" name="country" [(ngModel)]="newCustomer.country" required>
        </label>
        <label>Contact Person *
          <input class="form-control" name="contact_person" [(ngModel)]="newCustomer.contact_person" required>
        </label>
        <label>Contact Phone *
          <input class="form-control" name="contact_phone" [(ngModel)]="newCustomer.contact_phone" placeholder="+971..." required>
        </label>
        <label>Email *
          <input type="email" class="form-control" name="email" [(ngModel)]="newCustomer.email" required email>
        </label>
        <label>Subscription Model *
          <select class="form-control" name="sub_model" [(ngModel)]="newCustomer.sub_model" required>
            <option *ngFor="let m of subModels" [value]="m">{{ m | titlecase }}</option>
          </select>
        </label>
        <label>Subscription Start Date *
          <input type="date" class="form-control" name="sub_start_date" [(ngModel)]="newCustomer.sub_start_date" required>
        </label>
      </div>
      <div class="add-modal-footer">
        <button type="button" class="btn btn-light" (click)="closeAddModal()" [disabled]="isSaving">Cancel</button>
        <button type="submit" class="btn-add-customer" [disabled]="!addForm.valid || !isCustomerValid() || isSaving">
          Save
        </button>
      </div>
    </form>
  </div>
</div>

<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-clip-rotate"
  [fullScreen]="true">
</ngx-spinner>